import React from "react";
import { BiPlus } from "react-icons/bi";
import { Link } from "react-router-dom";
function ButtonToAdd(props) {
  return (
    <button
      onClick={props.onClick}
      className="flex justify-start items-center transition duration-150 mt-1 hover:scale-105 active:scale-100 text-xs md:text-base text-bgwhite bg-btnbgcolor py-2 px-5 rounded"
    >
      <span className="mr-2 p-1  bg-bgwhite text-btnbgcolor rounded-full">
        <BiPlus />
      </span>
      <span>{props.text}</span>
    </button>
  );
}

export default ButtonToAdd;
